export default function getDataFetchingClientStatus(errorState) {
  if (errorState && errorState.networkError && errorState.networkError.status) {
    if (errorState.networkError.status === 403) {
      return 403;
    } else if (errorState.networkError.status === 404) {
      return 404;
    }
  }
  return null;
}